import { Component, OnInit, Injector, Inject } from '@angular/core';
import { BodyWorkOrderService } from '../../../../ve.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { WorkOrdersService } from '../../../work-orders.service';
import { FilterableService } from '../../../../filterable-service';

@Component({
  selector: 'body-wo-submit-report',
  templateUrl: './body-wo-submit-report-dialog.component.html',
  styleUrls: ['./body-wo-submit-report-dialog.component.css']
})
export class BodyWoSubmitReportDialogComponent implements OnInit {
  data: any = {};
  selectedOption: any;
  contacts: any[];
  defaultContacts: any;
  service: BodyWorkOrderService;
  workOrderService: WorkOrdersService;
  plannedCompletionDate: any;
  disabled = true;
  submitStatus = new FilterableService();

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<BodyWoSubmitReportDialogComponent>,
    private readonly injector: Injector
  ) {
    this.service = this.injector.get(BodyWorkOrderService);
    this.workOrderService = this.injector.get(WorkOrdersService);
    this.data = data;
    this.plannedCompletionDate = data.plannedCompletionDate;
    this.submitStatus.next(this.workOrderService.submitStatus.value);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  checkStatus() {
    const oldStatus = this.data.woStatus;
    const newStatus = this.submitStatus.value.find(x => {
      return x.Id === this.workOrderService.bodyWoSubmitReportForm.value.StatusId;
    });

    if (oldStatus === newStatus.Id) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  getStatus() {
    const oldStatus = this.data.woStatus;
    const newStatus = this.submitStatus.value.find(x => {
      return x.Id === this.workOrderService.bodyWoSubmitReportForm.value.StatusId;
    });

    if (oldStatus === 'Complete') {
      this.submitStatus.next(this.workOrderService.submitStatus.value.filter(x => {
        if (x.Description === 'Complete') {
          return x;
        }
      }));
      return newStatus.Description;
    }

    if (newStatus.Description === 'Complete') {
      this.submitStatus.next(this.workOrderService.submitStatus.value.filter(x => x.Description !== 'Cancelled'));
    }
    if (newStatus.Description !== 'Assigned') {
      this.submitStatus.next(this.workOrderService.submitStatus.value.filter(x => x.Description !== 'Assigned'));
    }

    return newStatus.Description;
  }

  onYesClick(): any {
    this.dialogRef.close(this.workOrderService.bodyWoSubmitReportForm.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isDisabled() {
    return this.disabled || !this.workOrderService.bodyWoSubmitReportForm.valid;
  }
}
